import React, {FC, ReactNode} from "react"
import {OverlayTrigger} from "react-bootstrap"

import id from "@irati/utils/id"

import {useTheme} from "../global/useTheme"
import {OverlayProps, OverlayPlacement} from "./Overlay"
import {Overlay} from "./"

export interface TooltipProps extends Omit<OverlayProps, "theme"> {
  tooltipChildren: ReactNode
  id?: string
  onEntered?: () => void
  delayHide?: number
}

const Tooltip: FC<TooltipProps> = ({children, placement = OverlayPlacement.Right, tooltipChildren, onEntered, delayHide, ...props}) => {
  const idNamespace = id("Tooltip", props)
  const theme = useTheme()

  return (
    <OverlayTrigger
      onEntered={onEntered}
      id={id("trigger", idNamespace)}
      placement={placement}
      delayHide={delayHide}
      overlay={
        <Overlay id={idNamespace} theme={theme}>
          {tooltipChildren}
        </Overlay>
      }>
      {children}
    </OverlayTrigger>
  )
}

export default Tooltip
